import Choices from 'choices.js';

require('@nathanvda/cocoon');

import * as AutoKana from 'vanilla-autokana';

window.AutoKana = AutoKana;

require('packs/commons/validation');
import { msEmailDomains } from 'packs/commons/validation';

$(function () {
  // 初期表示時のみの処理用フラグ
  let isInitialPage = true;

  // 金融機関の選択肢生成
  const bankCodeSelect = new Choices($('#regular_donation_bank_code').get(0), {
    itemSelectText: 'Enterで選択',
    classNames: { containerInner: 'form-select' },
    searchResultLimit: 1000,
  });

  // 支店の選択肢生成
  const branchCodeSelect = new Choices($('#regular_donation_branch_code').get(0), {
    itemSelectText: 'Enterで選択',
    shouldSort: false,
    placeholder: true,
    placeholderValue: '',
    classNames: { containerInner: 'form-select' },
    searchResultLimit: 1000,
  });

  // 金融機関の変更処理
  $(bankCodeSelect.passedElement.element).on('change', async function () {
    const branchOptions = [{ value: '', label: '選択してください', placeholder: true }];
    if ($(this).val()) {
      const requires = await $.ajax({
        url: '/bank-account-donation/bank_requires',
        method: 'get',
        data: {
          bank_id: $(this).val(),
        },
      });
      if (requires.is_required_branch_code) {
        $('.js-branch_code_area').show();
        if (!isInitialPage) {
          validator.settings.ignore = ':hidden:not(#regular_donation_bank_code,#regular_donation_branch_code)';
        }
      } else {
        $('.js-branch_code_area').hide();
        if (!isInitialPage) {
          validator.settings.ignore = ':hidden:not(#regular_donation_bank_code)';
        }
      }
      if (requires.is_required_account_type) {
        $('.js-account_type_area').show();
      } else {
        $('.js-account_type_area').hide();
      }
      if (requires.is_required_account_number) {
        $('.js-account_number_area').show();
      } else {
        $('.js-account_number_area').hide();
      }
      if (requires.is_required_account_name) {
        $('.js-account_name_area').show();
      } else {
        $('.js-account_name_area').hide();
      }

      const data = await $.ajax({
        url: '/bank-account-donation/branches',
        method: 'get',
        data: {
          bank_id: $(this).val(),
        },
      });

      data.forEach(function (branch) {
        branchOptions.push({
          value: branch.code,
          label: branch.name + '(' + branch.code.toString().padStart(3, '0') + ')',
        });
      });
    } else {
      $('.js-branch_code_area').hide();
      $('.js-account_type_area').hide();
      $('.js-account_number_area').hide();
      $('.js-account_name_area').hide();
    }

    // 選択肢のエラーチェック
    if (!isInitialPage) {
      $('#regular_donation_bank_code').valid();
    }

    // 支店の初期選択肢
    branchCodeSelect.setChoices(branchOptions, 'value', 'label', true);
    if ($('#regular_donation_branch_code option:selected').val() === $('#regular_donation_branch_code').data('default-value')) {
      branchCodeSelect.setChoiceByValue($('#regular_donation_branch_code').data('default-value'));
    } else {
      branchCodeSelect.setChoiceByValue('');
    }
  });

  // 初期表示以外では金融機関の選択肢の変更を判定
  $('#regular_donation_bank_code').change();

  // 代表的金融機関のボタン処理
  $(document).on('click', '.js-set_bank_code', function () {
    const bank = $('#regular_donation_bank_code');
    const bankCode = $(this).data('bank-code').toString();
    if (bank.val() !== bankCode) {
      bankCodeSelect.setChoiceByValue(bankCode);
      bank.change();
    }
  });

  // 支店の変更処理
  $(branchCodeSelect.passedElement.element).on('change', async function () {
    // 選択肢のエラーチェック
    if (!isInitialPage) {
      $('#regular_donation_branch_code').valid();
    }
  });

  // 口座名義カナのひらがな→カタカナ対応と半角スペース対応
  $(document).on('change', '#regular_donation_account_name', function () {
    let result = $(this).val();

    // 半角カタカナを全角カタカナに変換
    result = result.normalize('NFKC');

    // ひらがなをカタカナに変換
    result = result.replace(/[\u3041-\u3096]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0x60));

    // 半角スペースを全角スペースに変換
    result = result.replace(/\s/g, '　');

    $(this).val(result);
  });

  // 使途を追加するボタン
  $(document)
    .on('cocoon:after-insert', '#js-detail_area', function (e, insertedItem) {
      initNewUsage();
      modifyList();
      $(insertedItem)
        .find('.js-other_amount_input')
        .rules('add', {
          required: true,
          number: true,
          min: 500,
          messages: {
            required: '金額を入力してください',
            number: '金額は半角数字で入力してください',
            min: '金額は500以上の値にしてください',
          },
        });
    })
    .on('cocoon:after-remove', '#js-detail_area', modifyList);

  // 使途の増減ボタンの表示条件
  function modifyList() {
    const detailCount = $('.nested-fields').length;
    if (detailCount <= 1) {
      $('.js-detail_delete_button').hide();
    }
    if (detailCount >= 4) {
      $('#js-detail_add_button').hide();
    }
    if (2 <= detailCount && detailCount <= 3) {
      $('.js-detail_delete_button').show();
      $('#js-detail_add_button').show();
    }
    uniqueUsage();
  }

  modifyList();

  $(document).on('change', '.js-usage_select', function () {
    uniqueUsage();
  });

  $(document).on('click', '#js-delivery_notice_dialog_button', function () {
    $('#js-delivery_notice_dialog_background').fadeIn('fast');
    $('#js-delivery_notice_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '#js-payment_timing_dialog_button', function () {
    $('#js-payment_timing_dialog_background').fadeIn('fast');
    $('#js-payment_timing_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '#js-enable_bank_list_dialog_button', function () {
    $('#js-enable_bank_list_dialog_background').fadeIn('fast');
    $('#js-enable_bank_list_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '#js-bank_account_dialog_button', function () {
    $('#js-bank_account_dialog_background').fadeIn('fast');
    $('#js-bank_account_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '.js-dialog_background,.js-dialog_close_button', function () {
    $('.js-dialog_background').fadeOut('fast');
    $('.js-dialog').fadeOut('fast');
  });

  $(document).on('click', '.js-privacy_policy_label', function () {
    if ($('#js-privacy-policy').prop('checked')) {
      $(this).addClass('checked');
    } else {
      $(this).removeClass('checked');
    }
  });

  // 使途を新規追加した場合の初期選択肢
  function initNewUsage() {
    const selectedUsages = $('.js-usage_select:not(:last)')
      .map(function (index, select) {
        return select.value;
      })
      .get();
    $('.js-usage_select:last option').each(function (index, option) {
      if (!selectedUsages.includes(option.value)) {
        option.selected = true;
        return false;
      }
    });
    $('.js-detail-area:last .js-amount_select[value=3000]').prop('checked', true);
    $('.js-detail-area:last input[type=hidden][name$="[amount_select]"]').val(3000);
    $('.js-amount_hidden:last').val(3000);
  }

  // 使途の選択肢の重複不可の処理
  function uniqueUsage() {
    const selectedUsages = $('.js-usage_select')
      .map(function (index, select) {
        return select.value;
      })
      .get();
    $('.js-usage_select option').prop('disabled', false);
    $('.js-usage_select').each(function (index, select) {
      $(select)
        .find('option')
        .each(function (i, option) {
          if ($(option).prop('selected')) {
            return;
          }
          if (selectedUsages.includes(option.value)) {
            $(option).prop('disabled', true);
          }
        });
    });
  }

  // 金額選択と入力の処理
  $(document).on('change', '.js-amount_select', function () {
    const area = $(this).parents('.js-amount_area');
    const value = $(this).val();
    if (value === 'other_amount') {
      // その他の金額選択時
      const otherAmount = area.find('.js-other_amount_input');
      otherAmount.prop('disabled', false);
      area.find('.js-amount_hidden').val(otherAmount.val());
    } else {
      const otherAmount = area.find('.js-other_amount_input');
      const otherAmountValue = otherAmount.val();
      otherAmount.prop('disabled', true);
      // エラーがある場合に回避するため一瞬適正な値を格納
      otherAmount.val(500);
      otherAmount.valid();
      otherAmount.val(otherAmountValue);
      area.find('.js-amount_hidden').val(value);
    }
  });

  // その他金額を入力したときの処理
  $(document).on('change', '.js-other_amount_input', function () {
    const area = $(this).parents('.js-amount_area');
    area.find('.js-amount_hidden').val($(this).val());
  });

  // 名前入力のカタカナ補完
  AutoKana.bind('#regular_donation_last_name', '#regular_donation_last_name_kana', { katakana: true });
  AutoKana.bind('#regular_donation_first_name', '#regular_donation_first_name_kana', { katakana: true });

  // 電話番号の入力補完(ハイフン除去)
  $(document).on('change', '#regular_donation_tel', function () {
    $(this).val($(this).val().replaceAll('-', ''));
  });

  // 郵便番号の入力補完
  $(document).on('input', '#regular_donation_postal_code', function () {
    var postalCode = $(this).val().replaceAll('-', '');
    if (postalCode.length <= 6) {
      return;
    }

    new YubinBango.Core(postalCode, function (address) {
      $('#regular_donation_address1').val(address.region).valid();
      $('#regular_donation_address2')
        .val(address.locality + address.street)
        .valid();
    });
  });

  // 確認ボタン
  $(document).on('click', '#js-confirm-button', function () {
    if ($('#js-donation-form').valid()) {
      $(window).scrollTop(0);
      setConfirmValues();
      $('#js-input-area').hide();
      $('#js-alert-dialog-area').hide();
      $('#js-confirm-area').show();
      $('#js-donation-input-step').removeClass('current');
      $('#js-donation-confirm-step').addClass('current');
      // ブラウザバック対応
      window.history.pushState({ page: 'confirm' }, null, '');
    } else {
      // エラーを画面中央に持ってくる
      const firstErrorOffset = $('label.form-error:visible:first').offset();
      const scrollTop = firstErrorOffset ? firstErrorOffset.top : 0;
      $(window).scrollTop(scrollTop - $(window).height() / 2);
    }
  });

  // 確認画面の内容を生成
  function setConfirmValues() {
    $('#js-bank_code_text').text($('#regular_donation_bank_code option:selected').text());
    $('#js-branch_code_text').text($('#regular_donation_branch_code option:selected').text());
    $('#js-account_type_text').text($('label[for=' + $('input[name="regular_donation[account_type]"]:checked').prop('id') + ']').text());
    $('#js-account_number_text').text($('#regular_donation_account_number').val());
    $('#js-account_name_text').text($('#regular_donation_account_name').val());
    const birthedOnYear = $('#regular_donation_birthed_on\\(1i\\)').val();
    if (birthedOnYear) {
      const birthedOn = birthedOnYear + '年' + $('#regular_donation_birthed_on\\(2i\\)').val() + '月' + $('#regular_donation_birthed_on\\(3i\\)').val() + '日';
      $('#js-birthed_on_text').text(birthedOn);
    }
    $('#js-payment_timing_text').text($('label[for=' + $('input[name="regular_donation[payment_timing]"]:checked').prop('id') + ']').text());
    const details = $('#js-details_text');
    details.empty();
    let totalAmount = 0;
    $('.js-detail-area').each(function (i, detail) {
      const detailDom = $('<li></li>');
      detailDom.append('<p class="confirm-text" style="white-space: pre;">' + $(detail).find('.js-usage_select option:selected').text() + '</p>');
      const amount = parseInt($(detail).find('.js-amount_hidden').val());
      detailDom.append('<p class="text-bold">' + amount.toLocaleString() + '円</p>');
      details.append(detailDom);
      totalAmount += amount;
    });
    details.append($('<li class="total-amount">1回ごとのご寄付合計金額:' + totalAmount.toLocaleString() + '円</li>'));
    $('#js-name_text').text($('#regular_donation_last_name').val() + '　' + $('#regular_donation_first_name').val());
    $('#js-name_kana_text').text($('#regular_donation_last_name_kana').val() + '　' + $('#regular_donation_first_name_kana').val());
    $('#js-email_text').text($('#regular_donation_email').val());
    $('#js-tel_text').text($('#regular_donation_tel').val());
    const address =
      '〒' +
      $('#regular_donation_postal_code').val() +
      '\n' +
      $('#regular_donation_address1').val() +
      $('#regular_donation_address2').val() +
      $('#regular_donation_address3').val() +
      $('#regular_donation_address4').val();
    $('#js-address_text').text(address);
    $('#js-receipt_kind_text').text($('label[for=' + $('input[name="regular_donation[receipt_kind]"]:checked').prop('id') + ']').text());
    $('#js-active_report_kind_text').text($('label[for=' + $('input[name="regular_donation[active_report_kind]"]:checked').prop('id') + ']').text());
    $('#js-direct_mail_kind_text').text($('label[for=' + $('input[name="regular_donation[direct_mail_kind]"]:checked').prop('id') + ']').text());
    $('#js-mail_news_kind_text').text($('label[for=' + $('input[name="regular_donation[mail_news_kind]"]:checked').prop('id') + ']').text());
    $('#js-is_mypage_requested_text').text($('label[for=' + $('input[name="regular_donation[is_mypage_requested]"]:checked').prop('id') + ']').text());
    $('#js-privacy_policy_text').text($('#js-privacy-policy').prop('checked') ? '同意する' : '同意しない');
  }

  // 戻るボタン
  $(document).on('click', '#js-back-button', function () {
    $(window).scrollTop(0);
    $('#js-confirm-area').hide();
    $('#js-input-area').show();
    $('#js-donation-input-step').addClass('current');
    $('#js-donation-confirm-step').removeClass('current');
    // ブラウザバック対応
    window.history.pushState({ page: 'input' }, '', '');
  });

  // 送信ボタン
  $(document).on('click', '#js-submit-button', async function () {
    // reCAPTCHAのトークン更新
    const tokenInput = $('#g-recaptcha-response-data-bank-account-donation');
    if (tokenInput) {
      const token = await window.executeRecaptchaForBankAccountDonationAsync();
      tokenInput.val(token);
    }
    $('#js-donation-form').submit();
  });

  // バリデーション
  const validator = $('#js-donation-form').validate({
    errorClass: 'form-error',
    highlight: function (element) {
      $(element).addClass('has-error');
    },
    unhighlight: function (element) {
      $(element).removeClass('has-error');
    },
    ignore: ':hidden:not(#regular_donation_bank_code)',
    groups: {
      birthedOnGroup: 'regular_donation[birthed_on(1i)] regular_donation[birthed_on(2i)] regular_donation[birthed_on(3i)]',
    },
    rules: {
      'regular_donation[bank_code]': {
        required: true,
      },
      'regular_donation[branch_code]': {
        required: true,
      },
      'regular_donation[account_number]': {
        required: true,
        maxlength: 7,
        number: true,
      },
      'regular_donation[account_name]': {
        required: true,
        maxlength: 60,
        katakana: true,
      },
      'regular_donation[regular_donation_details_attributes][0][other_amount]': {
        required: true,
        number: true,
        min: 500,
      },
      'regular_donation[regular_donation_details_attributes][1][other_amount]': {
        required: true,
        number: true,
        min: 500,
      },
      'regular_donation[regular_donation_details_attributes][2][other_amount]': {
        required: true,
        number: true,
        min: 500,
      },
      'regular_donation[regular_donation_details_attributes][3][other_amount]': {
        required: true,
        number: true,
        min: 500,
      },
      'regular_donation[regular_donation_details_attributes][4][other_amount]': {
        required: true,
        number: true,
        min: 500,
      },
      'regular_donation[last_name]': {
        required: true,
        maxlength: 50,
      },
      'regular_donation[first_name]': {
        required: true,
        maxlength: 50,
      },
      'regular_donation[last_name_kana]': {
        required: true,
        maxlength: 100,
        katakana: true,
      },
      'regular_donation[first_name_kana]': {
        required: true,
        maxlength: 100,
        katakana: true,
      },
      'regular_donation[birthed_on(1i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'regular_donation[birthed_on(2i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'regular_donation[birthed_on(3i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'regular_donation[email]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true,
        maxlength: 255,
      },
      'regular_donation[email_confirmation]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true,
        maxlength: 255,
        equalTo: '#regular_donation_email',
      },
      'regular_donation[tel]': {
        required: true,
        jpPhoneNumber: true,
        maxlength: 20,
      },
      'regular_donation[postal_code]': {
        required: true,
        postalCode: true,
        maxlength: 10,
      },
      'regular_donation[address1]': {
        required: true,
      },
      'regular_donation[address2]': {
        required: true,
        maxlength: 50,
      },
      'regular_donation[address3]': {
        required: true,
        maxlength: 255,
      },
      'regular_donation[address4]': {
        maxlength: 255,
      },
      'regular_donation[privacy_policy]': {
        required: true,
      },
    },
    messages: {
      'regular_donation[bank_code]': {
        required: '銀行を入力してください',
      },
      'regular_donation[branch_code]': {
        required: '支店コードを入力してください',
      },
      'regular_donation[account_number]': {
        required: '口座番号を入力してください',
        maxlength: '口座番号は7文字以内で入力してください',
        number: '口座番号は半角数字で入力してください',
      },
      'regular_donation[account_name]': {
        required: '口座名義カナを入力してください',
        maxlength: '口座名義カナは60文字以内で入力してください',
        katakana: '口座名義カナは全角カタカナで入力してください',
      },
      'regular_donation[regular_donation_details_attributes][0][other_amount]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
      },
      'regular_donation[regular_donation_details_attributes][1][other_amount]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
      },
      'regular_donation[regular_donation_details_attributes][2][other_amount]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
      },
      'regular_donation[regular_donation_details_attributes][3][other_amount]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
      },
      'regular_donation[regular_donation_details_attributes][4][other_amount]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
      },
      'regular_donation[last_name]': {
        required: '姓を入力してください',
        maxlength: '姓は50文字以内で入力してください',
      },
      'regular_donation[first_name]': {
        required: '名を入力してください',
        maxlength: '名は50文字以内で入力してください',
      },
      'regular_donation[last_name_kana]': {
        required: 'セイを入力してください',
        maxlength: 'セイは100文字以内で入力してください',
        katakana: 'セイはカタカナで入力してください',
      },
      'regular_donation[first_name_kana]': {
        required: 'メイを入力してください',
        maxlength: 'メイは100文字以内で入力してください',
        katakana: 'メイはカタカナで入力してください',
      },
      'regular_donation[birthed_on(1i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'regular_donation[birthed_on(2i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'regular_donation[birthed_on(3i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'regular_donation[email]': {
        required: 'メールアドレスを入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレスには${msEmailDomains.join('、')}のメールアドレスは使用できません。`,
        maxlength: 'メールアドレスは255文字以内で入力してください',
      },
      'regular_donation[email_confirmation]': {
        required: 'メールアドレス(確認用)を入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレス(確認用)には${msEmailDomains.join('、')}のメールアドレスは使用できません。`,
        maxlength: 'メールアドレス(確認用)は255文字以内で入力してください',
        equalTo: 'メールアドレスが一致しません',
      },
      'regular_donation[tel]': {
        required: '電話番号を入力してください',
        jpPhoneNumber: 'ハイフン抜きの電話番号形式で入力してください',
        maxlength: '電話番号は20文字以内で入力してください',
      },
      'regular_donation[postal_code]': {
        required: '郵便番号を入力してください',
        postalCode: '郵便番号形式で入力してください',
        maxlength: '郵便番号は10文字以内で入力してください',
      },
      'regular_donation[address1]': {
        required: '都道府県を入力してください',
      },
      'regular_donation[address2]': {
        required: '市区町村を入力してください',
        maxlength: '市区町村は50文字以内で入力してください',
      },
      'regular_donation[address3]': {
        required: '丁目番地を入力してください',
        maxlength: '丁目番地は255文字以内で入力してください',
      },
      'regular_donation[address4]': {
        maxlength: '建物名・部屋番号は255文字以内で入力してください',
      },
      'regular_donation[privacy_policy]': {
        required: 'プライバシーポリシーに同意してください',
      },
    },
  });

  // ブラウザ履歴での移動対応
  $(window).on('popstate', function (e) {
    const state = e.originalEvent.state;
    if (state) {
      if (state.page === 'confirm') {
        $('#js-input-area').hide();
        $('#js-alert-dialog-area').hide();
        $('#js-confirm-area').show();
        $('#js-donation-input-step').removeClass('current');
        $('#js-donation-confirm-step').addClass('current');
      } else {
        $('#js-confirm-area').hide();
        $('#js-input-area').show();
        $('#js-donation-input-step').addClass('current');
        $('#js-donation-confirm-step').removeClass('current');
      }
    }
  });

  // ブラウザバック対応
  window.history.replaceState({ page: 'input' }, '', '');

  // 初期表示を終了
  isInitialPage = false;
});
